import { toast } from "react-toastify";
import { MODES, OBJECT_TYPES } from "../../configuratorConstants";
import { validateProjectState, generateId } from "../../configuratorUtils";

const floorHasStairs = (floorObjects) => {
  return floorObjects.some((obj) => obj.type === OBJECT_TYPES.STAIRS);
};

export const handleFloorAction = (state, action, t) => {
  switch (action.type) {
    case "ADD_FLOOR": {
      const MAX_FLOORS = 3;
      if (state.floors.length >= MAX_FLOORS) {
        setTimeout(() => toast.error(t("toasts.maxFloorsReached")), 0);
        return state;
      }
      if (
        state.activeMode === MODES.FRAMELESS ||
        state.activeMode === MODES.FRAME
      ) {
        setTimeout(() => toast.warn(t("warnings.floorsInFrameless")), 0);
        return state;
      }
      if (!validateProjectState(state.projectObjects, state.floors, t)) {
        return state;
      }
      const highestFloorIndex = state.floors.length - 1;
      const highestFloorId = state.floors[highestFloorIndex].id;
      const highestFloorObjects = state.projectObjects[highestFloorId] || [];
      if (!floorHasStairs(highestFloorObjects)) {
        setTimeout(() => toast.error(t("toasts.noStairsOnTopFloor")), 0);
        return state;
      }
      const newFloorNumber = state.floors.length + 1;
      const newFloor = {
        id: generateId("floor_"),
        name: `${t("statusBar.floor")} ${newFloorNumber}`,
      };
      return {
        ...state,
        floors: [...state.floors, newFloor],
        projectObjects: {
          ...state.projectObjects,
          [newFloor.id]: [],
        },
        currentFloorId: newFloor.id,
        selectedObjectId: null,
      };
    }

    case "DELETE_FLOOR": {
      const floorIdToDelete = action.payload;
      const indexToDelete = state.floors.findIndex(
        (f) => f.id === floorIdToDelete,
      );

      if (indexToDelete === -1) return state;

      if (indexToDelete === 0 && state.floors.length > 1) {
        setTimeout(() => toast.error(t("toasts.cannotDeleteFirstFloor")), 0);
        return state;
      }

      if (state.floors.length === 1) {
        setTimeout(() => toast.error(t("toasts.cannotDeleteLastFloor")), 0);
        return state;
      }

      const newFloors = state.floors.slice(0, indexToDelete);
      const newProjectObjects = {};
      newFloors.forEach((floor) => {
        newProjectObjects[floor.id] = state.projectObjects[floor.id];
      });

      const newCurrentFloorId =
        newFloors.length > 0 ? newFloors[newFloors.length - 1].id : null;

      setTimeout(() => toast.info(t("toasts.deleteFloorAndAbove")), 0);

      return {
        ...state,
        floors: newFloors,
        projectObjects: newProjectObjects,
        currentFloorId: newCurrentFloorId,
        selectedObjectId: null,
      };
    }

    case "CLEAR_CURRENT_FLOOR": {
      const currentFloorId = state.currentFloorId;
      if (!currentFloorId) return state;

      setTimeout(
        () =>
          toast.success(
            t("toasts.allObjectsDeleted", {
              defaultValue: "Всі об'єкти видалено",
            }),
          ),
        0,
      );

      return {
        ...state,
        projectObjects: {
          ...state.projectObjects,
          [currentFloorId]: [],
        },
        selectedObjectId: null,
      };
    }

    case "SWITCH_TO_FLOOR": {
      if (!validateProjectState(state.projectObjects, state.floors, t)) {
        return state;
      }
      if (state.floors.some((f) => f.id === action.payload)) {
        return {
          ...state,
          currentFloorId: action.payload,
          selectedObjectId: null,
        };
      }
      return state;
    }

    default:
      return null;
  }
};
